export enum FilterMemberType {
    Unspecified = 0,
    HasEmail = 1,
    HasPhoneNumber = 2
}